import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable, NgZone} from '@angular/core';
import {FetchActions, FetchMin} from './history.actions';
import {HistoryService} from '../services/history.service';
import {tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HistoryAction} from '../models'


export class HistoryStateModel {
  public items: HistoryAction[];
  public loading: boolean;
  public dataLoaded: boolean;
  public nextPage: string;
  public minDate: Date;
}


@State<HistoryStateModel>({
  name: 'history',
  defaults: {
    items: [],
    loading: false,
    dataLoaded: false,
    nextPage: '',
    minDate: null,
  }
})
@Injectable()
export class HistoryState {

  @Action(FetchActions)
  fetchActions(ctx: StateContext<HistoryStateModel>, action: FetchActions) {
    const state = ctx.getState();
    ctx.patchState({loading: true});

    const queryParams = this.functiongetJsonFromUrl(action.link);

    const page = parseInt(queryParams['page']);
    let link = page ? `/api/history/action/?page=${page}&` : '/api/history/action/?';

    return this.historyService.fetchActions(`${link}start=${action.start}&end=${action.end}`).pipe(
      tap((response: any) => {
        let items;
        if(action.concat) {
          items = state.items.concat(response['results']);
        } else {
          items = response['results'] ;
        }
        ctx.patchState({
          items: items as HistoryAction[],
          loading: false,
          dataLoaded: true,
          nextPage: response['next']
        });
      })
    );
  }

  @Action(FetchMin)
  fetchMin(ctx: StateContext<HistoryStateModel>, action: FetchMin) {
    const state = ctx.getState();
    ctx.patchState({loading: true});

    return this.historyService.fetchMin().pipe(
      tap((response: any) => {
        ctx.patchState({
          minDate: response['min'] ? new Date(response['min']) : new Date()
        });
      })
    );
  }

  functiongetJsonFromUrl(url) {
    if(!url) url = location.search;
    var query = url.substr(1);
    var result = {};
    query.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  }

  constructor(private historyService: HistoryService,
              private ngZone: NgZone,
              private snackBar: MatSnackBar,
              private store: Store) {
  }

}
